if (!customElements.get('variant-select')) {
  class VariantSelect extends HTMLElement {
    constructor() {
      super();
      this.selectedOptions = {};
    }

    connectedCallback() {
      this.addEventListener('change', this.onOptionChange.bind(this));
    }

    onOptionChange(event) {
      const target = event.target.closest('[name^="option-"]');
      if (!target) return;

      const optionIndex = target.name.split('-')[1];
      this.selectedOptions[optionIndex] = target.value;
      this.currentVariant = this.findMatchingVariant();
      this.dispatchVariantChange(event);
    }

    findMatchingVariant() {
      const variantData = this.getVariantData();
      return variantData.find(variant => {
        return variant.options.every((option, index) => {
          return this.selectedOptions[index] === undefined || this.selectedOptions[index] === option;
        });
      }) || { id: null };
    }

    dispatchVariantChange(event) {
      publish(PUB_SUB_EVENTS.variantSelectChange, {
        data: {
          event,
          target: event.target,
          variant: this.currentVariant
        }
      });
    }

    getVariantData() {
      if (!this.variantData) {
        try {
          const jsonElement = this.querySelector('[type="application/json"]');
          this.variantData = JSON.parse(jsonElement.textContent);
          this.variantData = this.variantData.map(variant => ({
            ...variant,
            id: parseInt(variant.id)
          }));
        } catch (error) {
          console.error('Błąd parsowania danych wariantów:', error);
          this.variantData = [];
        }
      }
      return this.variantData;
    }
  }
  customElements.define('variant-select', VariantSelect);
}

if (!customElements.get('product-gallery')) {
  class ProductGallery extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.gallery = this.querySelector('.product-gallery');
    }

    setActiveMedia(mediaId) {
      const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
      if (!activeMedia) return;
      if (activeMedia.parentElement.firstChild !== activeMedia) {
        activeMedia.parentElement.prepend(activeMedia);
      }
      this.gallery.scrollTo({ left: activeMedia.offsetLeft, behavior: 'smooth' });
    }
  }
  customElements.define('product-gallery', ProductGallery);
}

if (!customElements.get('product-purchase')) {
  class ProductPurchase extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantSelectChange,
          this.handleOptionValueChange.bind(this)
      );
    }

    handleOptionValueChange({ data: { variant } }) {
      if (!variant || !variant.id) return;
      this.updateVariantId(variant.id);
      this.updateURL(this.dataset.url, variant.id);
      if (variant.featured_media) {
        this.updateMedia(variant.featured_media.id);
      }
    }

    updateVariantId(variantId) {
      document.querySelectorAll('[name="id"]').forEach(input => {
        input.value = variantId;
      });
    }

    updateURL(url, variantId) {
      if (this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
    }

    updateMedia(mediaId) {
      const productGallery = this.querySelector('product-gallery');
      if (productGallery) {
        productGallery.setActiveMedia(mediaId);
      }
    }
  }
  customElements.define('product-purchase', ProductPurchase);
}
